import { style, styleVariants } from "@vanilla-extract/css";
import {
  borderedCell,
  elementInTableCellWidth,
  statCellWidth,
  statusCellWidth,
} from "../../styles";
import { vars } from "../../styles/theme.css";

export const elementListRowStyles = style({
  borderBottom: vars.borders.outlineVariant,
});

const elementListRowData = style({
  padding: vars.space.xs,
  color: vars.colors.onSurface,
  fontFamily: vars.fonts.regular,
  fontSize: vars.fontSizes.body.s,
});

export const elementListStatus = style({
  width: statusCellWidth,
});

const baseElementListRowElement = style([
  borderedCell,
  { width: elementInTableCellWidth },
]);

export const elementListRowElement = styleVariants({
  default: [baseElementListRowElement],
  proposed: [
    baseElementListRowElement,
    {
      opacity: "60%",
    },
  ],
});

export const elementListStat = style([
  elementListRowData,
  {
    width: statCellWidth,
    textAlign: "center",
  },
]);

export const addElementButton = style({
  borderBottom: "1px solid transparent",
  padding: `0 ${vars.space.xs}`,
});
